export default "__VITE_ASSET__hIXimB2y__"